
export default {
  // Home page
  "airport_rankings": "공항 순위",
  "recent_reviews": "최근 리뷰",
  "loading_reviews": "리뷰 로딩 중...",
  "no_reviews": "아직 리뷰가 없습니다.",
  "share_experience": "경험 공유하기",
  "help_photographers": "공항 경험을 공유하여 다른 필름 사진작가들을 도와주세요",
  "add_review": "리뷰 추가",
  "loading_leaderboard": "순위표 로딩 중...",
  "no_reviews_yet": "아직 리뷰가 없습니다",
  "be_first": "공항을 처음으로 리뷰해보세요!",
  "best_airports": "최고의 공항",
  "worst_airports": "최악의 공항",
  "success_rate": "성공률",
  "airport_name": "공항 이름",
  "airport_location": "위치",
  "score": "점수",
  "total_reviews": "리뷰 수",
  "bottom_10_airports": "필름 사진작가 리뷰 기준 하위 10개 공항",
  "top_10_airports": "필름 사진작가 리뷰 기준 상위 10개 공항",
  // Review tabs
  "all_reviews": "모든 리뷰",
  "verified_reviews": "인증된 리뷰",
  "no_verified_reviews": "인증된 리뷰가 아직 없습니다.",
  "creative_reviews": "크리에이티브 리뷰",
  "traveler_reviews": "여행자 리뷰",
  "no_creative_reviews": "인증된 크리에이티브의 리뷰가 아직 없습니다.",
  "no_traveler_reviews": "인증된 여행자의 리뷰가 아직 없습니다."
};
